export default __webpack_public_path__ + "static/media/7SD52.ac8f55d9.jpg";